import { Link } from 'react-router-dom';
import FaqAccordion from '@/components/feature/FaqAccordion';
import { faqs } from '@/mocks/faqs';

export default function FaqSection() {
  return (
    <section className="w-full border-t border-background-200 bg-background-100 py-10 md:py-16" aria-label="常见问题">
      <div className="mx-auto grid max-w-[1280px] grid-cols-1 gap-8 px-4 md:px-6 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <span className="text-xs font-medium tracking-[0.2em] text-primary-600">常见问题</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            关于爆料网，你想知道的
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            我们把读者问得最多的几个问题整理在这里。如果还有疑问，欢迎直接给编辑组发邮件。
          </p>
          <div className="mt-6 rounded-xl border border-background-200 bg-background-50 p-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-50 text-lg text-primary-600">
                <i className="ri-customer-service-2-line" />
              </span>
              <div>
                <p className="text-sm font-medium text-foreground-900">还有别的问题？</p>
                <p className="text-xs text-foreground-500">工作日 24 小时内回复</p>
              </div>
            </div>
            <Link
              to="/about"
              className="mt-4 inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
            >
              前往关于我们
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
        <div className="lg:col-span-3">
          <FaqAccordion items={faqs} />
        </div>
      </div>
    </section>
  );
}